import SearchDetailContainer from "pages/SearchDetail/SearchDetailContainer";

/*
* 검색 > 더보기 화면
*/
export default SearchDetailContainer;